import { createSlice } from '@reduxjs/toolkit';
import { FrontendConfigurations } from '../../../types/interface';

const initialState: FrontendConfigurations = {
  taxRates: [],
  applicationConfig: [],
  total_household_income: 0,
  refundable_percentage_based_on_income: 0,
  total_household_income_per_person: 0
};

export const configSlice = createSlice({
  name: 'configuration',
  initialState,
  reducers: {
    setConfigurartionData: (state, action) => {
      state.applicationConfig = action.payload.applicationConfig;
      state.taxRates = action.payload.taxRates;
      state.total_household_income =
        action.payload.applicationConfig[0].total_household_income;
      state.refundable_percentage_based_on_income =
        action.payload.applicationConfig[0].refundable_percentage_based_on_income;
      state.total_household_income_per_person =
        action.payload.applicationConfig[0].total_household_income_per_person;
    }
  }
});
